const BRAIN_VERSION = "1.0.0"
export const getVersionFromLang = (lang: string) => {
  const language = lang === "ar" ? "ar_SA" : lang
  return `${language}_${BRAIN_VERSION}`
}
